module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "epub:type": "pagebreak",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0006#pref"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0007#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0008#ch01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1.")]), _vm._v("  Stacked Decks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0009#ch02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2.")]), _vm._v("  Building Inspections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0010#ch03"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3.")]), _vm._v("  Rentals and Relative Assessments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0011#ch04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4.")]), _vm._v("  Helping Out Homeowners: Changing Faces and Stubborn Realities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0012#ch05"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5.")]), _vm._v("  Justice Blockers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0013#conc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CONCLUSION.")]), _vm._v("  Reshuffling the Deck")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0014#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0015#appa"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("APPENDIX")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.")]), _vm._v("  Methodology")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0016#appb"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("APPENDIX")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("B.")]), _vm._v("  Building Violation Counts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0017#appc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("APPENDIX")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("C.")]), _vm._v("  Map of Strategic Task Force Inspections")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0018#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0019#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibartram0020#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11f5da24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-bartram-0005.vue
// module id = 66
// module chunks = 0